<mat-card [hidden]='hide'>
<div>
  <mat-card-title>{{title}}</mat-card-title>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</div>
<div class="icon-large">
  <img [src]="'/assets/images/icons/' + icon" onerror="this.style.display='none'"/>
</div>
</mat-card>
